import { ChangeDetectionStrategy, Component, Input, Output } from '@angular/core';
import { ScreenUtilsService } from 'core/services';
import { ProcessActionsService } from './process-actions.service';

@Component({
  selector: 'ss-process-action-template',
  templateUrl: './process-action-template.component.html',
  styleUrls: ['./process-action-template.component.scss'],
  providers: [ProcessActionsService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProcessActionTemplateComponent {

  readonly processSubject = this._processActionsService.processSubject;
  @Input() get process() {
    return this.processSubject.value
  }
  set process(value) {
    this.processSubject.next(value)
  }

  @Output()
  readonly actionCompleted = this._processActionsService.actionCompleted;

  readonly canCancelSubject = this._processActionsService.canCancelSubject;
  readonly canSignSubject = this._processActionsService.canSignSubject;
  readonly canDeleteSubject = this._processActionsService.canDeleteSubject;
  readonly canRejectSubject = this._processActionsService.canRejectSubject;
  readonly noMenuActionsSubject = this._processActionsService.noMenuActionsSubject;
  readonly canDownloadAuditTrailSubject = this._processActionsService.canDownloadAuditTrailSubject;
  readonly canDownloadSubject = this._processActionsService.canDownloadSubject;
  readonly canRestartSubject = this._processActionsService.canRestartSubject;
  readonly canChangeValidTillSubject = this._processActionsService.canChangeValidTillSubject;

  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs;

  constructor(
    private readonly _processActionsService: ProcessActionsService,
    private readonly _screenUtilsService: ScreenUtilsService
  ) {

  }

  reject() {

    this._processActionsService.reject();
  }

  cancel() {
    this._processActionsService.cancel();
  }

  deleteProcess() {
    this._processActionsService.deleteProcess();

  }

  downloadDocuments() {
    this._processActionsService.downloadDocuments();

  }

  downloadAuditTrail() {
    this._processActionsService.downloadAuditTrail();

  }

  sign() {
    this._processActionsService.sign()
  }

  restart() {
    this._processActionsService.restart()
  }

  changeValidTill() {
    this._processActionsService.changeValidTill()
  }

}

